
// Utility function to parse URLs and return an array of text and link elements
const parseMessage = (message) => {
  const urlRegex = /\b((?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})(?:[^\s]*)?)\b/gi;
  const parts = [];
  let lastIndex = 0;

  message?.replace(urlRegex, (url, match, offset) => {
    // Push text before URL
    if (lastIndex < offset) {
      parts.push({
        text: message.slice(lastIndex, offset),
        type: "text",
      });
    }

    const href = url?.startsWith("http://") || url?.startsWith("https://")
      ? url
      : `https://${url}`;

    // Push URL as a link
    parts.push({
      text: url,
      type: "link",
      href,
    });

    lastIndex = offset + url?.length;
  });

  // Push any remaining text
  if (lastIndex < message?.length) {
    parts.push({
      text: message?.slice(lastIndex),
      type: "text",
    });
  }

  return parts;
};

const TextMessage = ({ message }) => {

  const parsedMessage = parseMessage(message?.message);

  return (
    <div
      style={{
        whiteSpace: "pre-wrap", // This preserves line breaks and multiple spaces
        textDecorationLine: "none",
        margin: 0,
      }}
    >
      {parsedMessage.map((part, index) => {
        if (part.type === "link") {
          return (
            <a
              key={index}
              href={part.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {part.text}
            </a>
          );
        }
        return <span key={index}>{part.text}</span>;
      })}
    </div>
  );
};

export default TextMessage;
